module.exports = "/fonts/ElevanceSans-Regular.ea14329c288678136606469a070742c4.woff";